<template>
  <RegisterTemplate
    :title="$t('verificationStatus.accountOpening.title')"
    :activeTab="activeTab"
    :tabs="tabs"
    type="OpenAccount"
  />
</template>

<script>
import { mapState } from 'vuex';
import { RegisterRoutePath } from '@/router/registerRoutes';
import auditStatus from '@/constants/auditStatus';
import RegisterFormTab from '@/constants/register/registerFormTab';
import registerStep from '@/constants/register/registerStep';
import RegisterTemplate from '@/components/register/registerTemplate/RegisterTemplate.vue';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

const path = 'openAccount';

export default {
  name: 'OpenAccount',
  components: { RegisterTemplate },
  data() {
    return {
      tabs: [
        new RegisterFormTab({
          step: -1,
          regulator: this.regulator,
          title: 'verificationStatus.basicInformationStep'
        }),
        new RegisterFormTab({
          step: registerStep.personalInformation,
          regulator: this.regulator,
          pathName: `${path}/personalInformation`,
          title: 'verificationStatus.personalInformation'
        }),
        new RegisterFormTab({
          step: registerStep.accountConfiguration,
          regulator: this.regulator,
          pathName: `${path}/accountConfiguration`,
          title: 'verificationStatus.accountConfiguration'
        }),
        new RegisterFormTab({
          step: registerStep.openAccountStatus,
          regulator: this.regulator,
          pathName: `${path}/openAccountSuccess`,
          title: 'verificationStatus.depositNowOrIdVerification'
        })
      ]
    };
  },
  mounted() {
    if (this.currStep < registerStep.personalInformation) {
      this.$router.push(RegisterRoutePath.register);
    } else if (this.currStep > registerStep.openAccountStatus) {
      if (this.accountAuditStatus === auditStatus.completed) {
        this.setActiveTab(registerStep.idInformation);
      } else {
        this.$router.push(RegisterRoutePath.register);
      }
    } else {
      // Set to the latest step instead of prev viewing tab
      console.log('currStep');
      this.setActiveTab(this.currStep);
    }
    sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_VIEW, {
      openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV1
    })
  },
  computed: {
    accountAuditStatus() {
      return this.$store.state.common.accountAuditStatus;
    },
    ...mapState('register', ['currStep', 'activeTab'])
  },
  methods: {
    setActiveTab(tab) {
      this.$store.dispatch('register/setActiveTab', tab);
    }
  }
};
</script>

<style lang="scss" scoped></style>
